import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import { useInfiniteQuery } from "@tanstack/react-query";

export interface OutlookCalendarEventsListInput {
  filter?: string;
  orderBy?: string;
  maxResults?: number;
}

export interface OutlookCalendarEvent {
  id: string;
  subject: string;
  bodyPreview?: string;
  start: {
    dateTime: string;
    timeZone: string;
  };
  end: {
    dateTime: string;
    timeZone: string;
  };
  location?: {
    displayName: string;
  };
  attendees?: Array<{
    emailAddress: {
      name: string;
      address: string;
    };
    status?: {
      response: string;
    };
  }>;
  organizer?: {
    emailAddress: {
      name: string;
      address: string;
    };
  };
  webLink?: string;
  createdDateTime?: string;
  lastModifiedDateTime?: string;
  isAllDay?: boolean;
  showAs?: string;
}

export interface OutlookCalendarEventsResponse {
  "@odata.context": string;
  "@odata.nextLink"?: string;
  value: OutlookCalendarEvent[];
}

export function useOutlookCalendarEventsList(
  connection: IntegrationConnection,
  input: OutlookCalendarEventsListInput,
) {
  return useInfiniteQuery({
    queryKey: ["outlook-calendar-events-list", connection.id, input],
    queryFn: ({ pageParam = {} }) => {
      return orgAPI.toolbox.execute({
        integration_connection_id: connection.id,
        action_name: "microsoft-outlook-calendar-events-list",
        action_input: {
          ...input,
          ...pageParam,
        },
        // Typed entities drive the rich row UI; their generic projections ride
        // along in data_generic and are what get placed on the canvas.
        entity_format: "both",
      });
    },
    getNextPageParam: (lastPage) => {
      return lastPage.pagination?.next;
    },
    initialPageParam: {},
    enabled:
      !!input.filter || !!input.orderBy || input.maxResults !== undefined,
  });
}
